/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/whats_app/message_template/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdWhatsAppMessageTemplateId } from "./constants";
import type { GetWhatsAppMessageTemplateByIdResponse } from "./types";
import { isGetWhatsAppMessageTemplateByIdResponse } from "./validators";

export const getWhatsAppMessageTemplateById = reactQueryFetcherAdapter(
  engagementAppGroupIdWhatsAppMessageTemplateId,
  (signal: AbortSignal, appGroupId: string, id: string): Promise<GetWhatsAppMessageTemplateByIdResponse> => {
    return fetch(
      `/engagement/${appGroupId}/whats_app/message_template/${id}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetWhatsAppMessageTemplateByIdResponse
);
